"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formattedIndividualPersonasToCSV = exports.formattedIndividualPersonas = exports.findPersonasIndividual = void 0;

var _reselect = require("reselect");

var actions = _interopRequireWildcard(require("../actions"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var initialState = {
  isFetching: false,
  records: [],
  error: undefined
};

var findPersonasIndividual = function findPersonasIndividual( // $FlowFixMe
state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case actions.LOAD_INDIVIDUAL_REQUEST:
      return _extends({}, state, {
        isFetching: true
      });

    case actions.LOAD_INDIVIDUAL_SUCCESS:
      return _extends({}, state, {
        error: undefined,
        // $FlowFixMe
        records: [].concat(action.payload),
        isFetching: false
      });

    case actions.LOAD_INDIVIDUAL_FAILURE:
      return _extends({}, state, {
        isFetching: false,
        records: [],
        error: action.error
      });

    case actions.LOAD_INDIVIDUAL_EMPTY:
      return _extends({}, state, {
        error: undefined,
        isFetching: false,
        records: []
      });

    case actions.RESET_PAGE_DATA:
      return initialState;

    default:
      return state;
  }
};

exports.findPersonasIndividual = findPersonasIndividual;
var formattedIndividualPersonas = (0, _reselect.createSelector)(function (state) {
  return state.findPersonasIndividual.records;
}, function (state) {
  return state.selectedPersonas;
}, function (records, _ref) {
  var personas = _ref.personas,
      isHidden = _ref.isHidden;
  if (!records) return {};
  var personasToFilter = personas.map(function (_ref2) {
    var id = _ref2.id;
    return id;
  });
  return records.reduce(function (personaRecords, record) {
    var _personaRecords$recor, _extends2, _extends3;

    return !isHidden || personasToFilter.includes(record.segmentId) ? _extends({}, personaRecords, (_extends3 = {}, _extends3[record.segmentId] = {
      segmentId: record.segmentId,
      segmentLabel: record.segmentLabel,
      answers: _extends({}, (_personaRecords$recor = personaRecords[record.segmentId]) === null || _personaRecords$recor === void 0 ? void 0 : _personaRecords$recor.answers, (_extends2 = {}, _extends2[record.answerId] = {
        questionId: record.questionId,
        questionLabel: record.questionLabel,
        answerId: record.answerId,
        answerLabel: record.answerLabel,
        target: record.target,
        multiselect: record.multiselect,
        population: record.population,
        shareOfSegment: record.shareOfSegment,
        index: record.index,
        share: record.share,
        shareOfProperty: record.shareOfProperty,
        belowSample: record.belowSample
      }, _extends2))
    }, _extends3)) : personaRecords;
  }, {});
});
exports.formattedIndividualPersonas = formattedIndividualPersonas;
var formattedIndividualPersonasToCSV = (0, _reselect.createSelector)(formattedIndividualPersonas, function (state) {
  return state.selectedCharacteristics.characteristics;
}, function (state) {
  return state.selectedMeasure.measure;
}, function (state) {
  return state.audienceView.view.textSingular;
}, function (personaRecords, characteristics, measure, audienceView) {
  return {
    fields: [audienceView].concat(characteristics.map(function (_ref3) {
      var answerLabel = _ref3.answerLabel;
      return answerLabel;
    })),
    data: Object.entries(personaRecords).map(function (_ref4) {
      var personaID = _ref4[0],
          answers = _ref4[1].answers;
      return [personaID].concat(characteristics.map(function (_ref5) {
        var _answers$answerId;

        var answerId = _ref5.answerId;
        return (_answers$answerId = answers[answerId]) === null || _answers$answerId === void 0 ? void 0 : _answers$answerId[measure];
      }));
    })
  };
});
exports.formattedIndividualPersonasToCSV = formattedIndividualPersonasToCSV;